import { Component, Input, OnChanges } from '@angular/core';

import { FixtureViewType } from '@cds/betting-offer';
import {
    EventModel,
    EventParticipantType,
    PairGameScore,
    PeriodGameScore,
    ScoreboardType,
    SetGameScore,
} from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';

import { EpcotConfigService, EpcotModule } from '../../common/epcot-config.service';

export interface ScoreboardShowcaseViewModel {
    participant1Name: string;
    participant2Name: string;
}
@Component({
    selector: 'ms-showcase-scoreboard',
    templateUrl: 'showcase-scoreboard.component.html',
    standalone: false,
})
export class ScoreboardShowcaseComponent implements OnChanges {
    @Input() event: EventModel;
    module = EpcotModule.Scoreboard;

    vm: ScoreboardShowcaseViewModel = {
        participant1Name: '',
        participant2Name: '',
    };

    participant1Score: number;
    participant2Score: number;
    private isUSFormat: boolean;
    showAwayIndicator: boolean;
    isEpcotEnabled = false;

    constructor(
        public sitecore: Sitecore,
        private epcotConfigService: EpcotConfigService,
    ) {
        this.isEpcotEnabled = this.epcotConfigService.isEnabled(this.module);
    }

    private getParticipantsName(index: number): string {
        return this.event.participants[index].shortName || this.event.participants[index].name;
    }

    private isParticipant1AwayTeam(): boolean {
        return this.isUSFormat && this.event.participants[0].type === EventParticipantType.Away;
    }

    ngOnChanges(changes: ISimpleChanges<ScoreboardShowcaseComponent>): void {
        this.isUSFormat = this.event.viewType === FixtureViewType.American;
        this.showAwayIndicator = this.isParticipant1AwayTeam();
        this.vm = {
            participant1Name: this.getParticipantsName(0),
            participant2Name: this.getParticipantsName(1),
        };

        if (this.event.scoreboard.started) {
            switch (this.event.scoreboard.type) {
                case ScoreboardType.PeriodGame:
                    const periodGameScore = this.event.scoreboard.getScore<PeriodGameScore>()!;
                    this.participant1Score = periodGameScore.participant1.total;
                    this.participant2Score = periodGameScore.participant2.total;
                    break;
                case ScoreboardType.PairGame:
                    const pairGameScore = this.event.scoreboard.getScore<PairGameScore>()!;
                    this.participant1Score = pairGameScore.participant1;
                    this.participant2Score = pairGameScore.participant2;
                    break;
                case ScoreboardType.SetGame:
                    const setGameScore = this.event.scoreboard.getScore<SetGameScore>()!;
                    this.participant1Score = setGameScore.participant1WonSets;
                    this.participant2Score = setGameScore.participant2WonSets;
                    break;
                case ScoreboardType.BaseballGame:
                    const baseBallScore = this.event.scoreboard.getScore<SetGameScore>()!;
                    this.participant1Score = Number(baseBallScore.participant1.points);
                    this.participant2Score = Number(baseBallScore.participant2.points);
                    break;
            }
        }
    }
}
